<template>
  <div>
    <div v-show="!submitted">
      <DsForm
        :validation-errors="errors"
        @submit.prevent
      >
        <DsAlert v-if="errorMsg" type="error" class="mb-5">{{ errorMsg }}</DsAlert>

        <DsFormGroup
          :help="`Nach Absenden des Formulars ${duzen('erhältst du', 'erhalten Sie')} per E-Mail einen Link zum
          Einloggen im Finanzmanager. Bitte ${duzen('prüfe dein', 'prüfen Sie Ihr')} E-Mail-Postfach diesbezüglich.
          Bei diesem Verfahren ist kein Passwort notwendig.`"
          validation-name="email"
          label="E-Mail Adresse"
          label-for="email"
        >
          <DsInput
            id="email"
            v-model="form.email"
            immediate
            type="email"
            size="lg"
            required
          />
        </DsFormGroup>

        <div class="mt-10 space-y-2">
          <DsButton
            type="submit"
            variant="primary"
            size="lg"
            class="w-full"
            :handler="loginHandler"
          >
            Absenden
          </DsButton>
          <div class="max-lg:hidden text-muted text-center">Oder</div>
          <DsButton
            variant="outline"
            size="lg"
            class="w-full"
            @click="emit('switch-to-password')"
          >
            Über Passwort anmelden
          </DsButton>
        </div>
      </DsForm>
    </div>

    <div
      v-show="submitted && !loading"
      class="space-y-5"
    >
      <DsAlert type="success">
        Sofern {{ duzen('du einen Login besitzt', 'Sie einen Login besitzen') }}, haben wir
        {{ duzen('dir', 'Ihnen') }} eine Mail mit einem Zugangslink an <b>{{ form.email }}</b> verschickt.
        Bitte {{ duzen('überprüfe deinen', 'überprüfen Sie Ihren') }} Posteingang (sowie den Spamordner).
      </DsAlert>

      <DsButton
        variant="outline"
        size="lg"
        class="w-full"
        :handler="onReset"
      >
        Mit anderen Daten anmelden
      </DsButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DsAlert, DsButton, DsForm, DsFormGroup, DsInput } from '@demvsystems/design-components';

import { mailLogin } from '@/api/auth/authApi';
import { TrackEventCategory } from '@/application/utils/tracking/events';

import { useForm } from "@/api/lib/integration";
import { ref } from "vue";
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const emit = defineEmits(['switch-to-password']);

const { duzen } = useBaseDataStore();
const submitted = ref(false);

const { loading, form, errors, submit, reset, errorMsg } = useForm(
  mailLogin,
  { email: '' },
  () => { submitted.value = true },
);

const onReset = () => {
  reset();
  submitted.value = false;
};

const loginHandler = async () => {
  await submit();
  useTagManager().push({ event: TrackEventCategory.LOGIN_VIA_MAIL, action: 'anmelden' })
};
</script>
